"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserDetailsPositions = void 0;
const user_details_1 = require("@app/reducer/user-details");
const store_1 = require("@app/store");
const user_details_positions_1 = require("../../request/user-details-positions");
const employee_card_context_1 = require("../employee-card-context");
const useEmployeeCardData_1 = require("./useEmployeeCardData");
const useUserDetailsPositions = () => {
    const { workspace, userId } = (0, employee_card_context_1.useEmployeeCard)();
    const dispatch = (0, store_1.useRootDispatch)();
    const { data } = (0, useEmployeeCardData_1.useEmployeeCardData)({
        actionName: 'user-details-positions',
        requestor: async () => await (0, user_details_positions_1.requestUserDetailsPositions)({
            workspaceId: workspace?.id ?? '',
            userId: userId ?? '',
        }),
        reducer: (data) => dispatch((0, user_details_1.setUserPositions)(data?.positions)),
        selector: (state) => state.userDetails.positions,
        listenDeps: [workspace?.id, userId],
    });
    return data;
};
exports.useUserDetailsPositions = useUserDetailsPositions;
